
/*** common ***/
export const UPDATE_LOADING         = 'common/update_loading'

export const UPDATE_DIRECTION       = 'common/update_direction'

export const CHANGE_CUR_TAB         = 'common/change_cur_tab'

export const CHANGE_LOGIN_INFO      = 'common/change_login_info'

export const BIND_USER              = 'common/bind_user'

export const CHANGE_BOTTOM_STATUS   = 'common/change_bottom_status'

export const UPDATE_POSITION        = 'common/update_position'

export const UPDATE_SERVER_TIME     = 'common/update_server_time'

export const CHANGE_ALERT_TITLE     = 'common/change_alert_title'

export const UPDATE_CONFIRM_CONTENT = 'common/update_confirm_content'

/*** site ***/
export const CHANGE_INDEX_GOODS     = 'site/changeIndexGoods'

export const CHANGE_RECOMMEND       = 'site/changeRecommend'

export const CHANGE_BANNER          = 'site/changeBanner'

export const CHANGE_LASTEST         = 'site/changeLastest'

export const CHANGE_TOPIC           = 'site/topic'

/** category **/
export const CHANGE_TOP_CATEGORIES  = 'category/change_top_categories'

export const CHANGE_CATEGORY_LIST   = 'category/change_category_list'

export const CHANGE_CUR_GOODS       = 'category/change_cur_goods'

export const AJAX_UPDATE_GOODS      = 'category/ajax_updaye_goods'

/***  goods  ***/
export const CHANGE_GOODS           = 'goods/change_goods'

export const CHANGE_LIVESTOCK       = 'goods/change_livestock'

export const UPDATE_IS_FAVOR        = 'goods/update_is_favor'

/*** order ***/
export const CHANGE_ORDER_LIST      = 'order/change_order_list'

export const AJAX_UPDATE_LIST       = 'order/ajax_update_list'

export const CHANGE_ORDER_DETAIL    = 'order/change_order_detail'

export const AJAX_ORDER_STATUS      = 'order/ajax_order_status'

export const AJAX_ORDER_DETAIL_STATUS = 'order/ajax_order_detail_status'

/*** cart ***/
export const INIT_CARTS             = 'carts/init_carts'

export const AJAX_UPDATE_CARTS      = 'carts/ajax_update_carts'

export const AJAX_DELETE_CARTS      = 'carts/ajax_delete_carts'

export const AJAX_CHANGE_GOODS_NUM  = 'carts/ajax_change_goods_num'

export const AJAX_CHECK_GOODS       = 'carts/ajax_check_goods'

export const UNCHECK_ALL            = 'carts/uncheck_all'

export const UPDATE_CARTS_NUM       = 'carts/update_carts_num'

/*** settlement  ***/
export const CHANGE_SETTLEMENT      = 'settlement/change_settlement'

export const UPDATE_PRICES          = 'settlement/update_price'

/*** cashier ***/
export const INIT_CASHIER           = 'cashier/init_cashier'

export const UPDATE_CASHIER_PRICES  = 'cashier/update_cashier_prices'

/*** package ***/
export const AJAX_DEL_CARTS         = 'package/ajax_del_carts'

export const INIT_PACKAGE_GOODS     = 'package/init_package_goods'

export const AJAX_UPDATE_PACKAGE_GOODS  = 'package/ajax_update_list'

export const INIT_PACKAGE_INFO      = 'package/init_package_info'

export const AJAX_UPDATE_PACKAGE_CARTS = 'package/ajax_update_package_carts'

export const INIT_PACKAGE_LOGS      = 'package/init_package_logs'

export const AJAX_UPDATE_PACKAGE_LOGS = 'package/ajax_update_package_logs'

export const INIT_PACKAGE_LOG_DETAIL = 'package/init_package_log_detail'

export const AJAX_PACKAGE_REDUCE    = 'package/ajax_package_reduce'

export const AJAX_PACKAGE_ADD       = 'package/ajax_package_add'

export const AJAX_CANCEL_PACKAGE_ORDER  = 'package/ajax_cancel_package_order'

export const INIT_EDIT_PACKAGE      = 'package/init_edit_package'

/*** search ***/
export const CHANGE_SEARCH_LIST     = 'search/change_search_list'

export const AJAX_UPDATE_SEARCH     = 'search/ajax_update_search'

/***  article ***/
export const CHANGE_ARTICLE_LIST    = 'article/change_article_list'

export const AJAX_ARTICLE_LIST      = 'article/ajax_article_list'

export const CHANGE_ARTICLE_DETAIL  = 'article/change_article_detail'

/*** farmer ***/
export const INIT_FARMER_LIST       = 'farmer/init_farmer_list'

export const AJAX_UPDATE_FARMER_LIST = 'famer/ajax_update_farmer_list'

export const INIT_FARMER_DETAIL     = 'farmer/init_farmer_detail'

/*** standard ***/
export const INIT_STANDARD_LIST     = 'standard/init_standard_list'

export const AJAX_UPDATE_STANDARD_LIST = 'standard/ajax_update_standard_list'

export const INIT_STANDARD_DETAIL   = 'standard/init_standard_detail'

/*** activity ***/
export const INIT_ACTIVITY_DETAIL   = 'activity/INIT_ACTIVITY_DETAIL'

/*** recipe ***/
export const INIT_RECIPE_LIST       = 'recipe/init_recipe_list'

export const AJAX_UPDATE_RECIPE_LIST = 'recipe/ajax_update_recipe_list'

export const INIT_RECIPE_DETAIL     = 'recipe/init_recipe_detail'

/** events **/
export const UPDATE_EVENTS_LIST     = 'events/update_events_list'

/** discovef **/
export const INIT_DISCOVER_INDEX    = 'discover/init_discover_index'

/** member **/
export const CHANGE_CUR_ADDRESS     = 'member/change_cur_address'

export const CHANGE_ADDRESS_LIST    = 'member/change_address_list'

export const AJAX_CHANGE_ADDRESS    = 'member/ajax_change_address'

export const AJAX_DEL_ADDRESS       = 'member/ajax_del_address'

export const CHANGE_MEMBER_INFO     = 'member/change_member_info'

export const CHANGE_COUPON_LIST     = 'member/change_coupon_list'

export const AJAX_CHANGE_COUPON     = 'member/ajax_change_coupon'

export const CHANGE_RECHARGE_LIST   = 'member/change_recharge_list'

export const AJAX_UPDATE_RECHARGE   = 'member/ajax_update_recharge'

export const CHANGE_MY_FAVOR        = 'member/change_my_favor'

export const CHANGE_MY_PACKAGE        = 'member/change_my_package'

export const AJAX_UPDATE_FAVOR      = 'member/ajax_update_favor'

export const AJAX_DEL_FAVOR         = 'member/ajax_del_favor'

export const AJAX_CHANGE_MOBILE     = 'member/ajax_change_mobile'



// WEBPACK FOOTER //
// ./src/vuex/types.js